var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: _vm.isEdit ? "编辑推荐策略" : "新增推荐策略",
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "pram",
              attrs: {
                "label-width": "120px",
                model: _vm.pram,
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "策略名称：", prop: "strategyName" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "20",
                      "show-word-limit": "",
                      placeholder: "请输入策略名称",
                      clearable: "",
                    },
                    model: {
                      value: _vm.pram.strategyName,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "strategyName", $$v)
                      },
                      expression: "pram.strategyName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "商品来源：",
                    prop: "strategyType",
                    rules: [
                      {
                        required: true,
                        message: "请选择",
                        trigger: ["change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      on: { change: _vm.changeSourceType },
                      model: {
                        value: _vm.pram.strategyType,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "strategyType", $$v)
                        },
                        expression: "pram.strategyType",
                      },
                    },
                    _vm._l(_vm.filteredGoodsTypeMap, function (item) {
                      return _c(
                        "el-radio",
                        { key: item.key, attrs: { label: item.key } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.pram.strategyType == 1
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "绑定方式：",
                        prop: "goodsType",
                        rules: [
                          {
                            required: true,
                            message: "请选择",
                            trigger: ["change"],
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "small" },
                          model: {
                            value: _vm.pram.goodsType,
                            callback: function ($$v) {
                              _vm.$set(_vm.pram, "goodsType", $$v)
                            },
                            expression: "pram.goodsType",
                          },
                        },
                        [
                          [
                            _vm.pram.strategyType == 1
                              ? _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v("指定分类"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.pram.strategyType == 1
                              ? _c("el-radio", { attrs: { label: 3 } }, [
                                  _vm._v("指定SKU"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.pram.strategyType == 1
                              ? _c("el-radio", { attrs: { label: 5 } }, [
                                  _vm._v("指定SPU"),
                                ])
                              : _vm._e(),
                          ],
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pram.goodsType && _vm.pram.strategyType == 1
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "is-required",
                      attrs: {
                        label: "绑定内容：",
                        prop: "targetContent",
                        rules: [
                          {
                            validator: _vm.validateTargetContent,
                            trigger: ["change", "blur"],
                          },
                        ],
                      },
                    },
                    [
                      _vm.pram.goodsType == 1 && _vm.pram.strategyType == 1
                        ? _c("el-cascader", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              options: _vm.cateIdsOption,
                              props: {
                                children: "child",
                                label: "name",
                                value: "id",
                                multiple: true,
                                leaf: 3,
                              },
                              clearable: "",
                            },
                            model: {
                              value: _vm.pram.showCateId,
                              callback: function ($$v) {
                                _vm.$set(_vm.pram, "showCateId", $$v)
                              },
                              expression: "pram.showCateId",
                            },
                          })
                        : _vm.pram.goodsType == 3
                        ? _c(
                            "div",
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  type: "textarea",
                                  rows: 4,
                                  resize: "none",
                                  placeholder: "请输入skuId",
                                },
                                model: {
                                  value: _vm.pram.skuId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.pram, "skuId", $$v)
                                  },
                                  expression: "pram.skuId",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm.pram.goodsType == 5
                        ? _c(
                            "div",
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  type: "textarea",
                                  rows: 4,
                                  resize: "none",
                                  placeholder: "请输入spuId",
                                },
                                model: {
                                  value: _vm.pram.spuId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.pram, "spuId", $$v)
                                  },
                                  expression: "pram.spuId",
                                },
                              }),
                            ],
                            1
                          )
                        : _c("div", [_vm._v("请选择绑定方式")]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pram.strategyType == 80
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "排序方式：",
                        prop: "lypSortType",
                        rules: [
                          {
                            required: true,
                            message: "请选择排序方式",
                            trigger: ["change"],
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "small" },
                          model: {
                            value: _vm.pram.lypSortType,
                            callback: function ($$v) {
                              _vm.$set(_vm.pram, "lypSortType", $$v)
                            },
                            expression: "pram.lypSortType",
                          },
                        },
                        _vm._l(_vm.LYP_SORT_OPTIONS, function (o) {
                          return _c(
                            "el-radio",
                            { key: o.key, attrs: { label: o.key } },
                            [_vm._v(_vm._s(o.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "状态：", prop: "status" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-value": 1,
                      "inactive-value": 0,
                      "active-text": "启用",
                      "inactive-text": "禁用",
                    },
                    model: {
                      value: _vm.pram.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "status", $$v)
                      },
                      expression: "pram.status",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "关联小程序：",
                    prop: "appScope",
                    required: "",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.pram.appScope,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "appScope", $$v)
                        },
                        expression: "pram.appScope",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("全部")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("部分")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.pram.appScope === 1
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "选择小程序：",
                        prop: "companyAppIds",
                        required: "",
                        rules: [
                          {
                            validator: _vm.validateCompanyAppIds,
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { multiple: "", placeholder: "请选择小程序" },
                          model: {
                            value: _vm.pram.companyAppIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.pram, "companyAppIds", $$v)
                            },
                            expression: "pram.companyAppIds",
                          },
                        },
                        _vm._l(_vm.appOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "sort", required: "" } },
                [
                  _c(
                    "span",
                    {
                      staticClass: "sort-label",
                      attrs: { slot: "label" },
                      slot: "label",
                    },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: "数字越大，越优先在移动端展示",
                            placement: "top",
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-question sort-tip-icon",
                          }),
                        ]
                      ),
                      _vm._v("\n\t\t\t\t\t\t排序：\n\t\t\t\t\t"),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-input-number", {
                    staticStyle: { width: "60%" },
                    attrs: {
                      "controls-position": "right",
                      min: 0,
                      max: 99999,
                      precision: 0,
                      placeholder: "请输入排序",
                    },
                    model: {
                      value: _vm.pram.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "sort", $$v)
                      },
                      expression: "pram.sort",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "生效时间：",
                    prop: "isPermanently",
                    required: "",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.pram.isPermanently,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "isPermanently", $$v)
                        },
                        expression: "pram.isPermanently",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("永久")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v("有效期"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.pram.isPermanently === 0
                ? _c(
                    "el-form-item",
                    { attrs: { label: "有效期：", prop: "effectiveTime" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "activity-datetime-range",
                        attrs: {
                          type: "datetimerange",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss",
                          "default-time": _vm.effectiveTimeDefaultRange,
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                          "picker-options": _vm.effectiveTimePickerOptions,
                        },
                        on: {
                          "visible-change": _vm.onEffectiveTimePickerVisible,
                          change: _vm.onEffectiveTimeChange,
                        },
                        model: {
                          value: _vm.pram.effectiveTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.pram, "effectiveTime", $$v)
                          },
                          expression: "pram.effectiveTime",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitting },
                  on: { click: _vm.saveEdit },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }